const hasRecaptchaError = (value: unknown): boolean => {
  if (typeof value === 'string') {
    return /recaptcha/i.test(value)
  }

  if (Array.isArray(value)) {
    return value.some(hasRecaptchaError)
  }

  if (value && typeof value === 'object') {
    return Object.entries(value).some(([key, nestedValue]) => /recaptcha/i.test(key) || hasRecaptchaError(nestedValue))
  }

  return false
}

export const getSubmitErrorTranslationKey = (error: unknown, channel?: string) => {
  if (hasRecaptchaError(error)) return 'contact_us.page.errors.recaptcha_error'
  if (channel === 'callback') return 'contact_us.page.errors.callback_error'
  return 'contact_us.page.errors.general_error'
}
